// extracted by mini-css-extract-plugin
export default {"compliance_actions_dropdown_button":"mC1A7qj4jvRipnCbV_2S"};